import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqSectionComponent } from './faq-section.component';
import { SharedModule } from '../../shared/shared.module';
import { IconsModule } from '../../icons/icons.module';


@NgModule({
  declarations: [
    FaqSectionComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    IconsModule
  ],
  exports: [
    FaqSectionComponent
  ],
})
export class FaqSectionModule { }
